import { e as u } from "./chunk-base-D76d76ww.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function d(s) {
  return (c, i) => {
    const { slot: t, selector: r } = {}, l = "slot" + (t ? `[name=${t}]` : ":not([name])");
    return u(c, i, { get() {
      var n;
      const e = (n = this.renderRoot) == null ? void 0 : n.querySelector(l), o = (e == null ? void 0 : e.assignedElements(s)) ?? [];
      return r === void 0 ? o : o.filter(((m) => m.matches(r)));
    } });
  };
}
export {
  d as o
};
